import React from "react";
import WhyAura from "../components/home/WhyAura";
import Highlights from "../components/home/Highlights";
import Amenties from "../components/home/Amenties";
import Locations from "../components/home/Locations";
import Map from "../components/home/Map";
import Features from "../components/home/Features";
import Video from "../components/home/Video";
import HeroBanner from "../components/home/HeroBanner";
import HomeFaqs from "../components/home/HomeFaqs";
import MasterPlan from "../components/home/MasterPlan";
export default function Homepage() {
  return (
    <div>
      <HeroBanner />
      <Features />
      <Amenties />
      <Video />
      <Highlights />
      <WhyAura />
      <MasterPlan />
      <Locations />
      <HomeFaqs />
      <Map />
    </div>
  );
}
